import { Form, Text, NestedField, Checkbox, Field } from 'react-form';
import Select from 'react-select';

export class NextServiceSiteSelector extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            optionList: []
        }
    }

    componentDidMount() {
        var self = this;
        fetch(`/api/equipment/nextServiceSiteList`)
            .then((response) => response.json())
            .then((json) => {
                self.setState({ optionList: json });
            });
    }

    renderSiteTitle(site) {
        if (site.name == null) {
            return site.addressLine1;
        }

        return site.name;
    }


    render() {
        return (// Use the form field and your custom input together to create your very own input!
            <Field field={this.props.field} length={this.state.optionList.length}>
                {fieldApi => {

                    // Remember to pull off everything you dont want ending up on the <input>
                    // thats why we pull off onChange, onBlur, and field
                    // Note, the ...rest is important because it allows you to pass any
                    // additional fields to the internal <input>.
                    const { onChange, onBlur, field, ...rest } = this.props;

                    const { value, error, warning, success, setValue, setTouched } = fieldApi;

                    return (
                        <div>
                            <Select
                                {...rest}
                                name="form-field-name"
                                value={value}
                                options={this.state.optionList}
                                getOptionLabel={(option) => this.renderSiteTitle(option) }
                                getOptionValue={(option) => option.id}
                                onChange={value => {
                                    setValue(value);

                                    if (onChange) {
                                        onChange(value);
                                    }
                                }}
                                onBlur={ev => {
                                    setTouched();
                                    if (onBlur) {
                                        onBlur(ev);
                                    }
                                }} />
                        </div>
                    );
                }}
            </Field>);
    }
}